import { globalVal } from '../../global/globalvalues';
export const contactUs: any = {
    contactHeading: 'Contact Us',

    contactHpHeading: `${globalVal && globalVal.long_name} Help Center`,
    contactHpHeadingSupport: `For support`,
    contactHpHeadingPartner: `Partner with us!`,
    button: {
        link: 'https://learn.reachmobile.com/en',
        text: 'Visit help center',
    },
    helpCenter: `Get started with ${globalVal &&
        globalVal.short_name} and get answers to your account questions. Get in-depth on coverage, rates, device compatibility, account management and much more.`,

    chat: 'Chat with us',

    contactNo: '8444453665',

    email: 'reach@reachmobile.com',

    partners: ' partnerships@reachmobile.com ',

    partners1: ' media@reachmobile.com ',

    //address: `<b>${globalVal &&
      //  globalVal.long_name}</b><br>  285 Billerica Road, Chelmsford, Massachusetts,<br> United States, 01824`,
    address: `<b>${globalVal &&
        globalVal.long_name}</b><br>  6 Omni Way, Suite 202, Chelmsford,<br/> MA 01824`,
};
